module.exports = __webpack_public_path__ + "img/default_processing_gif.gif";